module.exports = __webpack_public_path__ + "static/media/29DUNON3.729250ac.jpg";